module.exports = __webpack_public_path__ + "static/media/spotify.39e066fc.svg";